import React from 'react';
import { IoCloseCircle } from 'react-icons/io5';

interface ImageModalProps {
  imageUrl: string;
  onClose: () => void;
}

const ImageModal: React.FC<ImageModalProps> = ({ imageUrl, onClose }) => {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <img
        src={imageUrl}
        alt="Full size"
        className="max-w-full max-h-full object-contain"
      />
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-white bg-red-500 rounded-full p-2"
      >
        <IoCloseCircle size={32} />
      </button>
    </div>
  );
};

export default ImageModal;
